import React from "react";
import {connect, ConnectedProps} from "react-redux";
import {AuthGState, Login, ADTE_LOGO_URL} from "@leap4/frontend";
import {RootState} from "../../../interfaces/root-state.interface";
import {BACKEND_SERVICE_NAME, meMultiUrl, requiredAuthRoles, setCookieUrl, loginUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";
const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    auth: AuthGState;
}


const LoginContainer = ({auth}: IProps) => {
    console.log(setCookieUrl)
    const user = auth.user;
    return <Login {...{user, redirectUrlForAuthenticated: urlService.sellers(), setCookieUrl, loginUrl}}
                  serviceName={BACKEND_SERVICE_NAME}
                  meUrl={meMultiUrl}
                  requiredRoles={requiredAuthRoles}
                  dashboardName={"PAPA2 Dashboard"}
                  imageURL={ADTE_LOGO_URL}
                  copyRights={{company: "ADTE",
                      website:"https://www.adte.com/" }}

    />;
}


export default connector(LoginContainer)
